<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-sync' class='navbarbtn' v-if='showSyncPower'
        @click='synchronization'>
        同 步
      </el-button>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.itemNumber' style='width: 125px;' placeholder='物料代码'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.itemName' style='width: 125px;' placeholder='物料名称'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :reduceHeight='200' :seqFixed='true'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :expandRowKeys='mainTable.expandRowKeys'
      :row-style='mainTableRowStyle'
      :showOperationsColumn='false'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>料号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 300px; text-align: left;'><span style='color: #42426F;'>名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 90px; text-align: left;'><span style='color: #42426F;'>交货日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>出库</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 80px; text-align: right;'><span style='color: #42426F;'>退货</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 350px; text-align: left;'><span style='color: #42426F;'>规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='ppoe in scope.data.row.detailDt1' :style='mainTableDetail1RowStyle(scope.data.row, ppoe)'
            :key='ppoe.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span>{{ppoe.EntryID}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span>{{ppoe.ItemNumber}} </span></div>
            <div class='expand-row' style='min-width: 300px; text-align: left;'><span>{{ppoe.ItemName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span>{{ppoe.Qty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 90px; text-align: left;'><span>{{ppoe.FetchDate ? ppoe.FetchDate.substring(0, 10) : ''}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span>{{ppoe.StockQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 80px; text-align: right;'><span>{{ppoe.BCommitQty}}{{ppoe.UnitName}} </span></div>
            <div class='expand-row' style='min-width: 350px; text-align: left;'><span>{{ppoe.ItemModel}} </span></div>
          </div>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import power from '@/components/sys/Power'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'
import dateTimeUtil from '@/utils/dateTimeUtil'

export default {
  name: 'SEOutStock',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'SM_SEOutStock',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        itemNumber: '',
        itemName: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      dateTimeUtil: dateTimeUtil,

      showSyncPower: false
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')
    power.setPower(that)

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.itemNumber) {
        const itemNumbers = that.mainTable.itemNumber.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNumbers.length; i++) {
          detail1FilterStr += " OR ItemNumber LIKE'%" + itemNumbers[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.itemName) {
        const itemNames = that.mainTable.itemName.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < itemNames.length; i++) {
          detail1FilterStr += " OR ItemName LIKE'%" + itemNames[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      if (data.row.TranType === '83') {
        if (data.row.Closed === '1' || data.row.Cancellation === 'True' || data.row.BClosed === '1') {
          return { 'background-color': '#aaaaaa' }
        } else if (data.row.Status === '3') {
          return { 'background-color': '#aaaaaa' }
        } else if (data.row.Status === '2' || data.row.Status === '1') {
          return {}
        }
      } else if (data.row.TranType === '82') {
        if (data.row.Closed === '1' || data.row.Cancellation === 'True' || data.row.BClosed === '1') {
          return { color: 'red', 'background-color': '#aaaaaa' }
        } else if (data.row.Status === '3') {
          return { color: 'red', 'background-color': '#aaaaaa' }
        } else if (data.row.Status === '2' || data.row.Status === '1') {
          return { color: 'red' }
        } else {
          return { color: 'red' }
        }
      }
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 展开行行样式设定方法
    mainTableDetail1RowStyle: function (row, ppoe) {
      if (row.TranType === '83') {
        if (row.Closed === '1' || row.Cancellation === 'True' || row.BClosed === '1') {
          return { color: 'blue', 'background-color': '#aaaaaa' }
        } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
          return { color: 'blue', 'background-color': '#cccccc' }
        }
      } else if (row.TranType === '82') {
        if (row.Closed === '1' || row.Cancellation === 'True' || row.BClosed === '1') {
          return { color: 'red', 'background-color': '#aaaaaa' }
        } else if (row.Status === '3' || ppoe.ErpClosed === '1') {
          return { color: 'red', 'background-color': '#cccccc' }
        } else {
          return { color: 'red' }
        }
      }
    },

    // 同步
    synchronization: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      const preNow = new Date()
      const rtnObj = await axiosHelper.handle('/WebSYSAction/Sync.SyncData', {
        syncCode: 'SM_SEOutStock',
        keyValue: ''
      })
      if (rtnObj.error === '000000') {
        const now = new Date()
        that.refreshMainTableContent()
        if (isNaN(rtnObj.msg)) {
          that.$message.success(rtnObj.msg)
        } else {
          that.$message.success('恭喜你，同步成功' + (rtnObj.msg) + '条！' + '共计耗时：' + ((now - preNow) / 1000) + '秒。')
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
  float: left;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
</style>
